export function upperCaseFirstWord(str: string): string {
  return str.charAt(0).toUpperCase() + str.slice(1)
}

export const shortText = (text: string, numberLength: number): string => {
  if (text.length <= numberLength) return text;
  return text.slice(0, numberLength) + '...';
}
